import { render } from "./RedirectPreferredDate.vue?vue&type=template&id=b752e80c"
import script from "./RedirectPreferredDate.vue?vue&type=script&lang=js"
export * from "./RedirectPreferredDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/RedirectPreferredDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b752e80c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b752e80c', __exports__)) {
    api.reload('b752e80c', __exports__)
  }
  
  module.hot.accept("./RedirectPreferredDate.vue?vue&type=template&id=b752e80c", () => {
    api.rerender('b752e80c', render)
  })

}


export default __exports__